import { createIntroOfferProductId } from '~/shared/helpers/createIntroOfferProductId'
import { createProductId } from '~/shared/helpers/createProductId'
import { selectScreenName } from '~/shared/store/common/selects'
import {
  selectStripeAccountId,
  selectStripeAccountName,
} from '~/shared/store/payment/selects'
import {
  selectSelectedSubscriptionCurrency,
  selectSelectedSubscriptionFullPrice,
  selectSelectedSubscriptionLookupKey,
  selectSelectedSubscriptionPeriodName,
  selectSelectedSubscriptionPeriodQuantity,
  selectSelectedSubscriptionTrialDays,
  selectSelectedSubscriptionTrialLookupKey,
  selectSelectedSubscriptionTrialPrice,
} from '~/shared/store/subscription/selects'
import { IAppState } from '~/shared/store/types'
import { selectUserEmail, selectUserUUID } from '~/shared/store/user/selects'

export const getPurchaseCommonEventParams = (state: IAppState) => {
  const uuid = selectUserUUID(state)
  const email = selectUserEmail(state)
  const stripePriceId = selectSelectedSubscriptionLookupKey(state)
  const price = selectSelectedSubscriptionFullPrice(state)
  const trialPrice = selectSelectedSubscriptionTrialPrice(state)
  const trialPeriodDays = selectSelectedSubscriptionTrialDays(state)
  const trialPriceId = selectSelectedSubscriptionTrialLookupKey(state)
  const trialPeriodQuantity = selectSelectedSubscriptionTrialDays(state)
  const currency = selectSelectedSubscriptionCurrency(state)
  const screenName = selectScreenName(state)
  const stripeAccountName = selectStripeAccountName(state)
  const stripeAccountId = selectStripeAccountId(state)
  const periodName = selectSelectedSubscriptionPeriodName(state)
  const periodQuantity = selectSelectedSubscriptionPeriodQuantity(state)

  const productId = trialPriceId
    ? createIntroOfferProductId({
        priceId: stripePriceId,
        trialPriceId,
        trialPeriodQuantity,
      })
    : createProductId({
        periodName,
        periodQuantity,
        price,
      })

  return {
    uuid,
    email,
    price,
    trialPrice,
    trialPriceId,
    trialPeriodDays,
    currency,
    periodName,
    periodQuantity,
    screenName,
    productId,
    stripeAccountName,
    stripeAccountId,
    stripePriceId,
  }
}
